<div class="content-compact"
[ngClass]="AppSettings.IsRunningInSingularity ? 'content-compact-sso' : ''">
    <!-- Header -->
    <div class="consoleHeader d-flex align-items-stretch"
    [ngClass]="AppSettings.IsRunningInSingularity ? 'consoleHeader-sso' : ''">
        <div class="row flex-nowrap w-100">
            <!-- Select Property -->
            <div class="col-auto d-flex header_section align-items-center">
                <div ngbDropdown
                     class="w-auto dropdown-noarrow"
                     *ngIf="lstProperties && lstProperties.length > 0">
                    <button type="button"
                            class="btn btn-link firstFilter"
                            ngbDropdownToggle
                            title="{{'TITLE.TITLE_SELECT_PROPERTY' | translate}}">
                        <i class="ksv-icon-building"></i>
                        <span class="font-weight-bold pl-3" style="font-size: 0.9rem" *ngIf="SelectedPropertyName">{{SelectedPropertyName}}</span>
                    </button>

                    <div class="dropdown-menu scrollable-dropdown-menu"
                         ngbDropdownMenu>
                        <button type="button"
                                class="dropdown-item pointer"
                                *ngFor="let row of lstProperties"
                                [ngClass]="{'active': RequestModel.PropertyId == row.PropertyId}"
                                (click)="onPropertyChange(row)">
                            {{row.PropertyName}}
                        </button>
                    </div>
                </div>
            </div>

            <!-- Select Status -->
            <!--<div class="col-auto topFilters header_section headerlink-2line">
                <a *ngFor="let row of PropStatModel"
                   [ngClass]="(FilterModel.SelectedTabId == row.Id ? 'active' : '')"
                   href="javascript:{}"
                   (click)="onTopFilterChange(row)">
                    <div class="text-center" translate>{{row.Label}}</div>
                    <div class="small text-center">({{row.Value}})</div>
                </a>
            </div>-->

            <!-- Search -->
            <div class="col-auto header_section d-flex align-items-center">
                <div class="w-auto mr-2">
                    <div class="searchFilterResult">
                        <input type="text"
                               [(ngModel)]="KeywordSearch"
                               name="KeywordSearch"
                               placeholder="Search"
                               (keyup.enter)="onSearchTextChange($event)"
                               class="form-control searchFilterResult" />
                    </div>
                </div>
            </div>

            <!-- Refresh -->
            <div class="col d-flex justify-content-end ml-auto">
                <div class="header_section align-items-center px-3">
                    <div class="pointer"
                         (click)="refresh()"
                         title="{{'TITLE.TITLE_REFRESH' | translate}}">
                        <i class="fa fa-lg fa-sync-alt"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Content -->
    <div class="jobconsole-body">
        <QuestionnaireSearchResult #grdSearchResult
                                   [RequestModel]="RequestModel"
                                   [FilterModel]="FilterModel"
                                   (onSelected)="onSelected($event)"
                                   (onCountUpdate)="didUpdateCount($event)">
        </QuestionnaireSearchResult>
    </div>
</div>

<QuestionnairePopover #detailPopover [Selected]="SelectedQuestionSet" (onAction)="didTakeActionOnQuestionSet($event)"></QuestionnairePopover>
<app-add-edit-question-set [DisplayMode]="2" *ngIf="EditModel" [EditMode]="EditMode" [EditModel]="EditModel" (onAction)="didTakeEditWindowAction($event)"></app-add-edit-question-set>
